<template>
  <CustomPage title="销售中心" style="background: #f7f7f7">
    <div slot="content" style="height: 100%">
      <div class="order-container">
        <div class="tabs">
          <div
            class="tab"
            :class="{ active: active === item.value }"
            v-for="item in tabs"
            :key="item.value"
            @click="tabClick(item.value)"
          >
            <span>{{ item.name }}</span>
          </div>
        </div>
        <van-search
          v-model.trim="searchValue"
          show-action
          placeholder="请输入订单的编号或手机号或收件人"
        >
          <template #action>
            <div @click="onSearch">搜索</div>
          </template>
        </van-search>
        <div class="list">
          <InSale
            :key="active"
            :tabType="active"
            :searchValue="searchValue"
            ref="InSale"
          />
        </div>
      </div>
      <CustomView />
    </div>
  </CustomPage>
</template>

<script>
import CustomPage from "@/components/custom-page.vue";
import CustomView from "@/components/custom-view.vue";
import InSale from "./components/InSale";
export default {
  components: { CustomPage, CustomView, InSale },
  data() {
    return {
      active: 0,
      tabs: [
        { name: "全部", value: 0 },
        { name: "待付款", value: 1 },
        { name: "待发货", value: 2 },
        { name: "待收货", value: 3 },
        { name: "已完成", value: 4 },
        { name: "售后", value: 5 },
      ],
      searchValue: "",
    };
  },
  created() {
    if (this.$route.query.hasOwnProperty("active")) {
      this.active = Number(this.$route.query.active);
    }
  },

  methods: {
    tabClick(val) {
      // 每次tab 点击 都清空搜索值
      this.searchValue = "";
      this.$refs.InSale.page = 0;
      this.$refs.InSale.list = [];
      if (val == 5) {
        this.$router.push({ name: "StoreAftSale" });
      } else {
        this.active = val;
      }
    },

    // 搜索框搜索
    onSearch() {
      this.$nextTick(() => {
        this.$refs.InSale.page = 0;
        this.$refs.InSale.finished = false;
        this.$refs.InSale.list = [];
        this.$refs.InSale.getData();
      });
    },
  },
};
</script>

<style lang="less" scoped>
.order-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  .tabs {
    display: flex;
    padding: 22px 0 20px;
    background: #fff;
    .tab {
      flex: auto;
      text-align: center;
      span {
        display: inline-block;
        padding: 8px 28px;
        font-size: 24px;
        color: #666;
        line-height: 24px;
      }
      &.active span {
        color: #fff;
        background: #e82035;
        border-radius: 40px;
      }
    }
  }
  .list {
    flex: 1;
    min-height: 0;
    overflow: hidden;
  }
}
</style>
